import { render, staticRenderFns } from "./InterventionsProcedure.vue?vue&type=template&id=34ab5f74&scoped=true"
import script from "./InterventionsProcedure.vue?vue&type=script&lang=js"
export * from "./InterventionsProcedure.vue?vue&type=script&lang=js"
import style0 from "./InterventionsProcedure.vue?vue&type=style&index=0&id=34ab5f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ab5f74",
  null
  
)

export default component.exports